import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  backgroundImage: 'linearGradient(to bottom right,#42C2FF,#F2C9E1)',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function SignUp() {
  const [values , setValues] = React.useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    
  })
  
  const handleChange = (prop) => (event) => {
    setValues({...values , [prop]: event.target.value});
  }
  
  
  const handleSubmit= async (event)=>{
    event.preventDefault();
    const body = {
      name:values.name,
      email:values.email,
      subject:values.subject,
      message:values.message
  }

  handleClose();

  console.log(body);

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  };
  
  try {
    const resp1 = await fetch('https://bhawna-jain-portfolio.herokuapp.com/sendContactData', requestOptions)

    if(resp1.ok){
      handleClick();
      // alert("submitted")
    }
    else
    // handleClicked();
      throw {msg: 'failed'}
  }
    
   catch (error) {
    console.log("Err ", error);
    error = (error.msg)?error.msg: "could not submit the form"; 
    // alert(error) ;
    handleClicked();
    
  }
}


const [open, setOpen] = React.useState(false);
const handleOpen = () => setOpen(true);
const handleClose = () => setOpen(false);


const [openPopUp, setOpenPopUp] = React.useState(false);
const [openPopUpError, setOpenPopUpError] = React.useState(false);

const handleClicked = () => {
setOpenPopUpError(true)
}


const handleClosePopError = (event, reason) => {
if (reason === 'clickaway') {
  return;
}

setOpenPopUpError(false);
};



const handleClick = () => {
setOpenPopUp(true);
};

const handleClosePop = (event, reason) => {
if (reason === 'clickaway') {
  return;
}

setOpenPopUp(false);
};




  return (
<>
    <Snackbar open={openPopUp} autoHideDuration={3000} onClose={handleClose}>
            <Alert onClose={handleClosePop} severity="success" sx={{ width: '100%' }}>
              Sent Successfully
            </Alert>
          </Snackbar>

          <Snackbar open={openPopUpError} autoHideDuration={3000} onClose={handleClose}>
            <Alert onClose={handleClosePopError} severity="error" sx={{ width: '100%' }}>
              Something went wrong
            </Alert>
          </Snackbar>

    <div>
    <Button variant="outlined" onClick={handleOpen} style={{height : '40px' , marginTop : '40px'}} >Sign Up</Button>
      
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Sign Up
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          <form onSubmit={handleSubmit} >  
        <div className="container"> 
        
          <div>
            <label>Name: </label>
            <br />  
            <input value = {values.name} onChange={handleChange('name')} type="text" placeholder="Your Name" name="Name" required  />
          </div> 
          <br />
          <div>
            <label htmlFor>Phone No :</label>
            <br />
            <input value = {values.subject} onChange={handleChange('subject')} width="20px" type="number" placeholder="Your Phone Number" name="Phone No" id />
          </div>
          <br />
          <div>
            <label htmlFor>Email Id</label>
            <br />
            <input value = {values.email} onChange={handleChange('email')} type="email" placeholder="abc@gmail.com" name="email-Id" />
          </div>
          <br />
          <div>
            <label> Yout Hobbies </label>   <br />
            <input value = {values.message} onChange={handleChange('message')} type="text" placeholder="Enter your hobbies" name="password" required />  
          </div>
          <br />
          <button type="submit">Sign Up</button>   
          <button type="reset" className="reset">Reset </button>
          <div>
            <input type="checkbox" defaultChecked="checked" /> Remember me   
          </div>
          <br />
          <div> 
            <h4>Already have an account</h4>
          </div>
        </div>
      </form>
          </Typography>
        </Box>
      </Modal>
    </div>

    </>
  );
}